
<mat-progress-bar 
    class="pending-list-progress-bar" 
    mode="determinate" 
    [value]="loadingProgress()"
    *ngIf="isDataLoading()"
></mat-progress-bar>

<input 
    type="text" 
    placeholder="Buscar dados na tabela" 
    class="search-input search-input-dimension" 
    (input)="search($event)"
    [disabled]="isDataLoading()"
>

<span class="preview-table-title">Preview das primeiras {{ total() }} de {{ fileTotalRows() }} linhas</span>
<cdk-virtual-scroll-viewport class="table-wrapper" [itemSize]="52" [maxBufferPx]="1200" [minBufferPx]="400">
    <table mat-table [dataSource]="tabularTableDataSource()">

        <ng-container *ngFor="let column of columns(); let i = index">
            <ng-container [matColumnDef]="'col_' + i">
                <th mat-header-cell *matHeaderCellDef> {{ column.name }} </th>
                <td mat-cell *matCellDef="let row">
                    {{ row[column.name] == "" ? '--' : row[column.name] }}
                </td>
            </ng-container>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns_ids(); sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columns_ids()"></tr>

    </table>
</cdk-virtual-scroll-viewport>

<mat-paginator 
    [length]="total()"
    [pageSize]="pageSize()"
    [pageSizeOptions]="pagesSizesArray"
    aria-label="Selecione a pagina"
    [showFirstLastButtons]="true"
    (page)="handlePageChange($event)">
</mat-paginator>

<div class="button-container">
    <button class="secondary" (click)="handleCancelClick()" [disabled]="isDataLoading()"> Cancelar </button>
    <button 
    class="primary" 
    [innerText]="isPreviewStep ? 'Iniciar importação' : 'Próximo'" 
    (click)="handleButtonClick()"
    [disabled]="isDataLoading()"
    ></button>
</div>

<app-alert 
title="Cancelar importação"
message="Deseja realmente cancelar essa importação? Todo o progresso será perdido."
confirmText="Confirmar"
cancelText="Voltar"
[visible]="isAlertVisible"
(onConfirmEvent)="handleCancelClickConfirmation()"
(onCancelEvent)="handleCancelClickCancel()"
></app-alert>